import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

// hack fix for resetting textarea on submit
// https://github.com/edmundhung/conform/pull/729

type BaseInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'key'>

interface InputPropsWithoutKey extends BaseInputProps {
	key?: string
}

export interface InputProps extends InputPropsWithoutKey {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-base file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid]:border-input-invalid',
					className,
				)}
				ref={ref}
				{...props}
			/>
		)
	},
)
Input.displayName = 'Input'

export { Input }
